/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

let progressBar = document.querySelector('.progress-bar');
if(progressBar){
    flkty = new Flickity('.Carousel');

    flkty.on( 'scroll', function( progress ) {
    progress = Math.max( 0, Math.min( 1, progress ) );
    progressBar.style.width = progress * 100 + '%';
    });
}

class Dropdown {
    constructor(container) {
      this.isOpen = false;
      this.activeIndex = undefined;

      this.container = container;
      this.button = container.querySelector(".Collapsible__Button");
      this.menu = container.querySelector(".Collapsible__Inner");
      this.items = container.querySelectorAll(".HorizontalList__Item");
    }

    initEvents() {
      if(this.button){
        this.button.addEventListener("click", this.toggle.bind(this));
      }
      document.addEventListener("click", this.onClickOutside.bind(this));
      document.addEventListener("keydown", this.onKeyEvent.bind(this));
    }

    toggle() {
      if(!document.querySelector('.PageOverlay.is-visible')) {
        this.isOpen = !this.isOpen;
        this.button.setAttribute("aria-expanded", this.isOpen);
        this.menu.setAttribute("aria-hidden", !this.isOpen);
        this.container.dataset.open = this.isOpen;
      }
    }

    onClickOutside(e) {
      if (!this.isOpen) return;

      let targetElement = e.target;

      do {
        if (targetElement == this.container) return;

        targetElement = targetElement.parentNode;
      } while (targetElement);

      this.toggle();
    }

    onKeyEvent(e) {
      if (!this.isOpen) return;

      if (e.key === "Tab") {
        this.toggle();
      }

      if (e.key === "Escape") {
        this.toggle();
        this.button.focus();
      }

      if (e.key === "ArrowDown") {
        this.activeIndex =
          this.activeIndex < this.items.length - 1 ? this.activeIndex + 1 : 0;
        this.items[this.activeIndex].focus();
      }

      if (e.key === "ArrowUp") {
        this.activeIndex =
          this.activeIndex > 0 ? this.activeIndex - 1 : this.items.length - 1;
        this.items[this.activeIndex].focus();
      }
    }
}

const dropdowns = document.querySelectorAll(".FiltersDropdown");
dropdowns.forEach((dropdown) => new Dropdown(dropdown).initEvents());

window.checkUnits = () => {
  const cartList = document.querySelector(".Cart__ItemList");

  let shoeUnit = localStorage.getItem('shoe') ? localStorage.getItem('shoe') : 'uk';
  let cmUnit = localStorage.getItem('cm') ? localStorage.getItem('cm') : 'cm';

  let shoeItems = document.querySelectorAll('.CartItem__Variant.shoe [data-unit="'+shoeUnit+'"]'),
      cmItems = document.querySelectorAll('.CartItem__Variant.cm [data-unit="'+cmUnit+'"]');

  document.querySelectorAll('.CartItem__Variant [data-unit]').forEach(unit => {
    unit.style.display = 'none';
  });

  shoeItems.forEach(unit => {
    unit.style.display = 'inline-block';
  });

  cmItems.forEach(unit => {
    unit.style.display = 'inline-block';
  });
}


window.sizes = () => {
  document.querySelectorAll('.sizes-toggle').forEach(sizeToggle => {
    if(sizeToggle){
      let element = sizeToggle.closest('.Collapsible'),
            sizeType = sizeToggle.dataset.type,
            storedUnit = localStorage.getItem(sizeType),
            variantDropdownLabel = document.querySelectorAll('.ProductForm__Option [data-variant-unit]');

      if(!storedUnit){
        if(sizeType == 'shoe')
          storedUnit = 'eu';
        if(sizeType == 'cm')
          storedUnit = 'cm';
      }

      element.querySelectorAll('input[name="sizeUnitShoe"], input[name="msizeUnitShoe"], input[name="sizeUnitCM"], input[name="msizeUnitCM"]').forEach((input) => {
        input.addEventListener('change', (e) => {
          let unit = e.target.value,
              currentUnit = element.querySelectorAll(".size-unit[data-unit='"+unit+"']"),
              allUnits = element.querySelectorAll(".size-unit");

          localStorage.setItem(sizeType, unit);

          allUnits.forEach((item) => {
            item.style.display = 'none'
          });
          currentUnit.forEach((item) => {
            item.style.display = 'inline-block'
          });

          if(variantDropdownLabel){
            variantDropdownLabel.forEach(label => {
              if(label.getAttribute('data-variant-unit') == unit){
                label.style.display = 'inline-block';
              } else {
                label.style.display = 'none';
              }
            });
          }
        });
      });

      let unitInputs = element.querySelectorAll('input[value="'+storedUnit+'"]')

      unitInputs.forEach((input) => {
        input.checked = true;
        input.dispatchEvent(new Event('change'));
      });
    }
  });
}
window.sizes();

document.addEventListener('variant:changed', function(event) {
  let deliveryTime = document.querySelector('.ProductForm__EstimatedDelivery .time'),
      addToCart = document.querySelector('.ProductForm__AddToCart'),
      variant = event.detail.variant,
      lowStockQty = document.querySelector('.ProductForm__LowQty'),
      sku = document.querySelector('.ProductMeta__SkuNumber')

  let stockLevel = window.variantsStock[variant.id];



  if(stockLevel > 0) {
    deliveryTime.querySelector('span').innerHTML = deliveryTime.dataset.standard;
    if(addToCart.querySelector('span')){
      addToCart.querySelector('span').innerHTML = addToCart.dataset.standard;
    }
  } else {
    if(window.variantsDeliveryTimePreorder[variant.id]){
      deliveryTime.querySelector('span').innerHTML = window.variantsDeliveryTimePreorder[variant.id];
    } else {
      deliveryTime.querySelector('span').innerHTML = deliveryTime.dataset.preorder;
    }
    if(addToCart.querySelector('span')){
      addToCart.querySelector('span').innerHTML = addToCart.dataset.preorder;
    }
  }

  if(lowStockQty){
    if(stockLevel > 0 && stockLevel < 3){
      lowStockQty.querySelector('span').innerHTML = stockLevel;
      lowStockQty.style.display = 'block';
    } else {
      lowStockQty.style.display = 'none';
    }
  }

  if(sku) {
  	sku.innerHTML = variant.sku
  }
});

document.addEventListener('theme:loading:start', function(){
  document.querySelector('body').style.cursor = 'wait';
});

document.addEventListener('theme:loading:end', function(){
  setTimeout(function(){
    checkUnits();
    document.querySelector('body').style.cursor = 'default';
  },500);
});

const hasSwatches = document.querySelectorAll('.ProductItem__Swatches');
console.log("Master Tags:");
const elements = document.querySelectorAll('[data-master-tag]');
const uniqueMasterTags = new Set();
elements.forEach(el => {
  uniqueMasterTags.add(el.dataset.masterTag);
});
console.log(Array.from(uniqueMasterTags)); // This will log an array of unique values

function loadSwatches() {
  const elements = document.querySelectorAll('[data-master-tag]');
  const uniqueMasterTags = new Set();
  elements.forEach(el => {
    uniqueMasterTags.add(el.dataset.masterTag);
  });
  uniqueMasterTags.forEach(masterTag => {
    fetch(`/collections/api/${masterTag}?view=json`)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        const products = data;
        let relatedProducts = document.querySelectorAll(`[data-master-tag="${masterTag}"][data-handle]`);

        relatedProducts.forEach(function (item) {
          let handle = item.dataset.handle;
          const swatchRow = item.closest('.ProductItem__Swatches');
          const currentHandle = swatchRow && swatchRow.dataset.currentHandle;

          if (!handle || handle === currentHandle) {
            item.remove();
            return;
          }

          if (products.hasOwnProperty(handle)) {
            item.setAttribute('href', products[handle].url);
            item.querySelector('.item__Bg').innerHTML = '<img class="Image--lazyLoad Image--fadeIn" data-src="' + products[handle].image + '" role="presentation" alt="">';
          } else {
            item.remove();
          }
        });

        let swatches = document.querySelectorAll('.isSwatch');
        swatches.forEach(function (swatch) {
          let count = swatch.querySelectorAll('.item--swatch').length;
          if (count < 1) {
            swatch.classList.remove('isSwatch');
          } else if (count > 4) {
            swatch.querySelector('.item--more span').innerHTML = parseFloat(count) - 3;
            swatch.querySelector('.item--more').style.display = 'block';
          } else {
            //swatch.querySelector('.item--more').remove();
          }
        });
      });
  });
}
if(hasSwatches) {
  loadSwatches();
}

let lang = window.navigator.languages ? window.navigator.languages[0] : null;
    lang = lang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;

let shortLang = lang;
if (shortLang.indexOf('-') !== -1)
    shortLang = shortLang.split('-')[0];

if (shortLang.indexOf('_') !== -1)
    shortLang = shortLang.split('_')[0];

// if((shortLang != 'de' || shortLang != 'at') && !localStorage.hasOwnProperty('redirect')) {
//   window.location.replace("https://heinrich-dinkelacker-com.myshopify.com?redirect");
//   localStorage.setItem('redirect', 'global');
// }

// if((shortLang == 'de' || shortLang == 'at') && !localStorage.hasOwnProperty('redirect')) {
//   window.location.replace("https://heinrich-dinkelacker.myshopify.com?redirect");
//   localStorage.setItem('redirect', 'global');
// }


// Cart counter watch
let observer = new MutationObserver(function(mutationsList, observer) {
    mutationsList.forEach(mutation => {
        if(parseInt(mutation.target.innerText) == '0'){
            mutation.target.classList.remove('is-visible');
        } else {
            mutation.target.classList.add('is-visible');
        }
    });
});
observer.observe(document.querySelector('.Header__Icon .Header__CartCount'), {
    characterData: false,
    childList: true,
    attributes: false
});



// Shoepassion Customs
jQuery(document).ready(function(){
  jQuery('[data-submit-newsletter]').on('click', function(e){
    e.preventDefault();
    jQuery('.Footer__Block--newsletter form [type="submit"]').click();
  });

  // Search
  let $search_form = $('.Header__Search');
  $('body').on('click', function(){
    if(matchMedia('only screen and (min-width: 1140px)').matches && matchMedia('only screen and (max-width: 1459px)').matches){
      $search_form.hide();
    }
  });
  $('.Header__Icon--search').on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    if(matchMedia('only screen and (min-width: 1140px)').matches && matchMedia('only screen and (max-width: 1459px)').matches){
      $search_form.show();
    }
  });
  $('.Header__Search').on('click', function(e){
    e.stopPropagation();
  });

  // Accordion
  let $headings = jQuery('.Accordion__Item-Heading'),
      $contents = jQuery('.Accordion__Item-Content');
  $headings.on('click', function(){
    let $heading = jQuery(this),
        $content = jQuery(this).next();
    $headings.not($heading).removeClass('active');
    $contents.not($content).slideUp(350);
    $heading.toggleClass('active');
    $content.slideToggle(350);
  });

  // Footer
  let $footer_titles = jQuery('.Footer__Block--links .Footer__Title'),
      $footer_lists = jQuery('.Footer__Block--links .Linklist');
  $footer_titles.on('click', function(){
    let $title = jQuery(this),
        $list = jQuery(this).next();
    $footer_titles.not($title).removeClass('active');
    $footer_lists.not($list).slideUp(350);
    $title.toggleClass('active');
    $list.slideToggle(350);
  });


  // Featured Items Slider
  let featured_items_slider = undefined;

  // Filters
  $('.Filters__Button').on('click', function(e){
    if( $(this).attr('aria-expanded') == 'false' ){
      $(this).attr('aria-expanded', true);
      $('.CollectionInner__Filters').addClass('show-all');
    } else {
      $(this).attr('aria-expanded', false);
      $('.CollectionInner__Filters').removeClass('show-all');
    }
  });

  // PDP Swatches
  $('.ProductForm .ColorSwatchList .HorizontalList__Item--more button').on('click', function(){
    $(this).attr('aria-expanded', true);
    $('.ProductForm .ColorSwatchList .ColorSwatchPhoto').show();
  });
  if( $('.ProductForm .ColorSwatchList .ColorSwatch.is-active').parent().index() > 5 ){
    $('.ProductForm .ColorSwatchList .HorizontalList__Item--more button').attr('aria-expanded', true);
    $('.ProductForm .ColorSwatchList .ColorSwatchPhoto').show();
  }

  $('.ProductForm .SizeSwatchList .Linklist__Checkbox').on('change', function(){
    let $collapsible_button = $(this).parents('.Collapsible').find('.Collapsible__Button');
    $(this).parent().find('.size-unit').each(function(){
      let unit = $(this).data('unit').toLowerCase(),
          value = $(this).text();
      $collapsible_button.attr('aria-expanded', false);
      if(unit == 'none') {
      	$collapsible_button.find('[data-variant-unit]').text(value);
      } else {
      	$collapsible_button.find('[data-variant-unit="'+unit+'"]').text(value);
      }

    });
  });

  $('body').on('click', function(e){
    if( !$(e.target).parents('.Collapsible').length ){
      $('.ProductForm__Variants .Collapsible__Button').attr('aria-expanded', false);
    }
  });

  $('.ProductForm__Variants .Collapsible__HeaderClose').on('click', function(){
    $('.ProductForm__Variants .Collapsible__Button').attr('aria-expanded', false);
  });


  $('.Linklist__Notify button').on('click', function(){
    $(this).parents('.Linklist__Item').find('label').click();
    setTimeout(function(){
      $('.ct_main .ct_button').trigger('click');
    }, 500);
  });

  $('[data-show-product-description]').on('click', function(){
    let $dsc = $('.ProductMeta__Description .Collapsible').eq(0).find('.Collapsible__Button');
    if($dsc.attr('aria-expanded') == 'false'){
      $dsc.click();
    }
    $('html, body').animate({
      scrollTop: $dsc.offset().top
    }, 500);
  });

  $('[data-scroll-to-reviews]').on('click', function(){
    let $el = $('[data-collapsible-reviews]');
    if($el.attr('aria-expanded') == 'false'){
      $el.click();
    }
    $('html, body').animate({
      scrollTop: $el.offset().top
    }, 500);
  });

  // Drawer
  $('body').delegate('.Drawer .Collapsible__Button', 'click', function(){
    var $collapsible = $(this).parents('.Drawer').find('.Collapsible'),
        $this_collapsible = $(this).parents('.Collapsible'),
        $header = $(this).parents('.Drawer').find('.Drawer__Heading'),
        $bottom = $(this).parents('.Drawer').find('.Drawer__Bottom');
    if($(this).attr('aria-expanded') == 'true'){
      $collapsible.not($this_collapsible).css('display', 'none');
      $this_collapsible.css('display', 'block');
      $header.css('display', 'none');
      $bottom.css('display', 'none');
    } else {
      $collapsible.css('display', 'block');
      $header.css('display', 'flex');
      $bottom.css('display', 'block');
    }
  });
  $('body').delegate('[data-action="close-drawer"]', 'click', function(){
    $(this).parents('.Drawer').find('.Collapsible').css('display', 'block');
    $(this).parents('.Drawer').find('.Drawer__Heading').css('display', 'flex');
    $(this).parents('.Drawer').find('.Collapsible__Button').attr('aria-expanded', false);
  });

  $('.Collapsible__Button--alt').on('click', function(e){
  	e.preventDefault();
    $('.Collapsible__Button').toggle();
    $(this).parents('li').toggleClass('expanded');
    $(this).parents('ul').toggleClass('expanded');
  });

  // Brand products
  $('[data-load-brand-products]').on('click', function(){
    $(this).parents('.BrandProducts').find('.BrandProducts__Item--hidden:lt(16)').removeClass('BrandProducts__Item--hidden').addClass('BrandProducts__Item--show');

    if(!$(this).parents('.BrandProducts').find('.BrandProducts__Item--hidden').length) {
      $(this).attr('aria-expanded', true);
      $(this).parents('.SectionFooter').hide();
    }
  });

  let $product_item_image = $('.ProductList .Grid__Cell').eq(0).find('.AspectRatio'),
      $collection_banner = $('.ProductList .Grid__Cell--banner');

  $(window).on('resize', function(){
    if(matchMedia('only screen and (max-width: 599px)').matches){
      if(featured_items_slider === undefined){
        featured_items_slider = $('.FeaturedItems__Slider').flickity({
          arrowShape: 'M73.8,0.2c1,0,1.9,0.4,2.6,1.1c1.5,1.5,1.5,3.8,0,5.3L33,49.9l43.4,43.4c1.5,1.5,1.5,3.8,0,5.3s-3.8,1.5-5.3,0L22.5,49.9L71.1,1.2C71.9,0.5,72.8,0.2,73.8,0.2z'
        });
      }
    } else {
      if(featured_items_slider !== undefined){
        featured_items_slider.flickity('destroy');
        featured_items_slider = undefined;
      }
    }
    if($collection_banner.length){
      $collection_banner.css('height', $product_item_image.height());
    }
  });



  $(window).trigger('resize');
});



let ukraine_menu = Array.from(document.querySelectorAll(".Linklist__Item a"));
ukraine_menu.forEach(e => {
  if (e.innerText == "Charity : Ukraine Edition") {
    e.classList.add("special_class");
    e.innerHTML = `<b>Charity:&nbsp</b>Ukraine Edition`;
  }
})

Array.from(document.querySelectorAll(".MegaMenu .Linklist__Item a")).forEach((item) => {
  if(item.innerHTML == "Crispinus Wochen") { item.style.color = "red";}
   if(item.innerHTML == "Sale") { item.style.color = "#111111";}
});

Array.from(document.querySelectorAll(".Collapsible__Inner .Collapsible__Content .Linklist__Item a")).forEach((item) => {
  if(item.innerHTML == "Black Weeks") { item.style.color = "red";}
});

Array.from(document.querySelectorAll(".Header__MainNav  .HorizontalList  .HorizontalList__Item a")).forEach((item) => {
  if(item.innerHTML == "Outlet") { item.style.color = "#c93434";}
});

Array.from(document.querySelectorAll(".Drawer__Container  .SidebarMenu__Nav  .Collapsible a")).forEach((item) => {
  if(item.innerHTML == "Outlet") { item.style.color = "#c93434";}
});

const size_selectors = Array.from(document.querySelectorAll(".sizes-toggle input"));
const size_text = document.querySelector(".size_update");
const size_text_belt = document.querySelector(".size_update_belt");
const localstorage_value = localStorage.getItem('shoe');
const localstorage_value_belt = localStorage.getItem('cm');
const shoe_classExists = document.getElementsByClassName('size_update').length > 0;
const belt_classExists = document.getElementsByClassName('size_update_belt').length > 0;

if(shoe_classExists){
  size_text.innerHTML = localstorage_value.toUpperCase();
  size_selectors.forEach(el => el.addEventListener("click", (e) => {
  size_text.innerHTML = e.target.value.toUpperCase();
  }));
}

if(belt_classExists){
  size_text_belt.innerHTML = localstorage_value_belt;
  size_selectors.forEach(el => el.addEventListener("click", (e) => {
  size_text_belt.innerHTML = e.target.value;
  }));
}

  setTimeout(() => {
    let add_review_link =document.querySelector("#ReviewsWidget .R-TextBody.R-TextBody--xs.u-marginTop--xs div.u-marginTop--xs");
    if(add_review_link){
      add_review_link.classList.add("R-Button","R-Button--primary","u-marginBottom--none");
    }
    //add_review_link.style.width="100%";
    console.log("working")
  }, "2000")

//size chart pop-up JS

let size_chart_popup = document.querySelector(".size_chart_popup");
let size_chart_popup_background = document.querySelector(".size_chart_popup_background");
let sizechart_close = document.querySelector(".sizechart_close");

function show_sizechart_pop_up() {
  size_chart_popup_background.style.display = "block";
  if(size_chart_popup){
    size_chart_popup.style.display = "block";
  }

}

function close_sizechart_popup() {
  size_chart_popup_background.style.display = "none";
  if(size_chart_popup){
    size_chart_popup.style.display = "none";
  }

}

if(size_chart_popup_background){
  size_chart_popup_background.addEventListener("click", () => {
    close_sizechart_popup();
  });
}


document.addEventListener("DOMContentLoaded", function () {
  var backToTopButton = document.getElementById("back-to-top");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 200) {
      backToTopButton.classList.add("show");
    } else {
      backToTopButton.classList.remove("show");
    }
  });

  backToTopButton.addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
});

// Loop through all links on the page and open external links (those with "www." in the hostname) in a new tab.
const links = document.links;

for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  const link = links[i];
  const isExternal = link.hostname !== window.location.hostname && link.hostname.startsWith('www.');

  if (isExternal) {
    link.target = '_blank';
    link.rel = 'noreferrer noopener';
  }
}

// JavaScript code to check if the canonical_url contains 'shoepassion.de'
var canonicalUrl = window.location.href;

if (canonicalUrl.includes('shoepassion.de-com')) {


  /*
  Luigi's Box
  */

  var privateKey = "your-secret";
  var publicKey = "485255-590113";
  var contentType = "application/json; charset=utf-8";

  var requestUri = request.url.replace(/^.*\/\/[^\/]+/, '').replace(/\?.*$/, '');
  var timestamp = new Date().toUTCString();
  var signature = [request.method, contentType, timestamp, requestUri].join("\n");

  var encryptedSignature = CryptoJS.HmacSHA256(signature, privateKey).toString(CryptoJS.enc.Base64);

  pm.request.headers.add({
      key: "Content-Type",
      value: contentType
  });
  pm.request.headers.add({
      key: "Authorization",
      value: "ApiAuth " + publicKey + ":" + encryptedSignature
  });
  pm.request.headers.add({
      key: "Date",
      value: timestamp
  });

}
